import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { APP_LABELS, FIELD_LENGTH } from '@config/app-config';
import Help from '@modules/shared/components/reusable-components/help';
import TextError from '@modules/shared/components/reusable-components/text-error';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import PartialSaveWarningPopup from '@modules/shared/components/reusable-components/partial-save-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import {
  resetReduxState,
  postOvernightCampDataParticipants,
  getOvernightCampDataParticipantsList
} from '@redux/overnight-camp-data-participations-and-enrollments/action';
import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';

import { GetParticipantsDataSelector } from '@redux/overnight-camp-data-participations-and-enrollments/selectors';

import helpicon from '@static/images/caretdoubleright.svg';

const Participants = props => {
  const formikref = useRef();
  const {
    status,
    setLoader,
    LoginUserData,
    ApiParameterData,
    handleResetRedux,
    GetParticipantsData,
    handlePostParticipants,
    handleGetParticipantsData,
    handleGetCampReportsDashboard
  } = props;

  const role = get(LoginUserData, 'user.role[0]');

  const [help, setHelp] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);
  const [totalIsNotEqual, setTotalIsNotEqual] = useState(false);
  const [errorMessageForTotal, setErrorMessageForTotal] = useState('');

  const [resStatus, setResStatus] = useState();

  const initialValues = {
    totalNumberOfUnique: '',
    totalOvernightSummerCampers: '',

    raceEthnicAsian: '',
    raceEthnicAsianNotCollected: false,

    raceEthnicBlackOrAfricanAmerican: '',
    raceEthnicBlackOrAfricanAmericanNotCollected: false,

    raceEthnicHispanicLatino: '',
    raceEthnicHispanicLatinoNotCollected: false,

    raceEthnicMiddleEasternOrNorthernAfrican: '',
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected: false,

    raceEthnicNativeAmericanOrAlaskanNative: '',
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected: false,

    raceEthnicNativeHawaiianOrOtherPacificIslander: '',
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected: false,

    raceEthnicWhite: '',
    raceEthnicWhiteNotCollected: false,

    raceEthnicTwoOrMoreRacesEthnicities: '',
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected: false,

    raceEthnicOther: '',
    raceEthnicOtherNotCollected: false,

    raceEthnicUnknown: '',
    raceEthnicUnknownNotCollected: false,

    raceEthnicTotalMembers: '',

    genderFemale: '',
    genderFemaleNotCollected: false,

    genderMale: '',
    genderMaleNotCollected: false,

    genderUnknown: '',
    genderUnknownNotCollected: false,

    genderTotalMembers: ''
  };

  const editValues = {
    totalNumberOfUnique:
      GetParticipantsData?.Participants?.TotNoOfUnDuplicatedCampersServed ??
      null,
    totalOvernightSummerCampers:
      GetParticipantsData?.Participants
        ?.TotNoOfOverNightSummerCampersReturning ?? null,

    raceEthnicAsian: GetParticipantsData?.Participants?.Asian ?? null,
    raceEthnicAsianNotCollected:
      GetParticipantsData?.Participants?.AsianNotCollected ?? false,

    raceEthnicBlackOrAfricanAmerican:
      GetParticipantsData?.Participants?.BlackOrAfricanAmerican ?? null,
    raceEthnicBlackOrAfricanAmericanNotCollected:
      GetParticipantsData?.Participants?.BlackOrAfricanAmericanNotCollected ??
      false,

    raceEthnicHispanicLatino:
      GetParticipantsData?.Participants?.HispanicLatino ?? null,
    raceEthnicHispanicLatinoNotCollected:
      GetParticipantsData?.Participants?.HispanicLatinoNotCollected ?? false,

    raceEthnicMiddleEasternOrNorthernAfrican:
      GetParticipantsData?.Participants?.MiddleEastNorthAfrican ?? null,
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected:
      GetParticipantsData?.Participants?.MiddleEastNorthAfricanNotCollected ??
      false,

    raceEthnicNativeAmericanOrAlaskanNative:
      GetParticipantsData?.Participants?.NativeAmericanAlaskanNative ?? null,
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected:
      GetParticipantsData?.Participants
        ?.NativeAmericanAlaskanNativeNotCollected ?? false,

    raceEthnicNativeHawaiianOrOtherPacificIslander:
      GetParticipantsData?.Participants?.NativeHawaiOtherPacificIslander ??
      null,
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected:
      GetParticipantsData?.Participants
        ?.NativeHawaiOtherPacificIslanderNotCollected ?? false,

    raceEthnicWhite: GetParticipantsData?.Participants?.White ?? null,
    raceEthnicWhiteNotCollected:
      GetParticipantsData?.Participants?.WhiteNotCollected ?? false,

    raceEthnicTwoOrMoreRacesEthnicities:
      GetParticipantsData?.Participants?.TwoOrMoreRaces ?? null,
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected:
      GetParticipantsData?.Participants?.TwoOrMoreRacesNotCollected ?? false,

    raceEthnicOther: GetParticipantsData?.Participants?.Other ?? null,
    raceEthnicOtherNotCollected:
      GetParticipantsData?.Participants?.OtherNotCollected ?? false,

    raceEthnicUnknown: GetParticipantsData?.Participants?.RaceUnknown ?? null,
    raceEthnicUnknownNotCollected:
      GetParticipantsData?.Participants?.RaceUnknownNotCollected ?? false,

    genderFemale: GetParticipantsData?.Participants?.Female ?? null,
    genderFemaleNotCollected:
      GetParticipantsData?.Participants?.FemaleNotCollected ?? false,

    genderMale: GetParticipantsData?.Participants?.Male ?? null,
    genderMaleNotCollected:
      GetParticipantsData?.Participants?.MaleNotCollected ?? false,

    genderUnknown: GetParticipantsData?.Participants?.Unknown ?? null,
    genderUnknownNotCollected:
      GetParticipantsData?.Participants?.UnknownNotCollected ?? false
  };

  const validationSchema = Yup.object({
    totalNumberOfUnique: Yup.string().nullable(),
    totalOvernightSummerCampers: Yup.string().nullable(),

    raceEthnicAsian: Yup.string().nullable(),
    raceEthnicAsianNotCollected: Yup.string().nullable(),

    raceEthnicBlackOrAfricanAmerican: Yup.string().nullable(),
    raceEthnicBlackOrAfricanAmericanNotCollected: Yup.string().nullable(),

    raceEthnicHispanicLatino: Yup.string().nullable(),
    raceEthnicHispanicLatinoNotCollected: Yup.string().nullable(),

    raceEthnicMiddleEasternOrNorthernAfrican: Yup.string().nullable(),
    raceEthnicMiddleEasternOrNorthernAfricanNotCollected:
      Yup.string().nullable(),

    raceEthnicNativeAmericanOrAlaskanNative: Yup.string().nullable(),
    raceEthnicNativeAmericanOrAlaskanNativeNotCollected:
      Yup.string().nullable(),

    raceEthnicNativeHawaiianOrOtherPacificIslander: Yup.string().nullable(),
    raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected:
      Yup.string().nullable(),

    raceEthnicWhite: Yup.string().nullable(),
    raceEthnicWhiteNotCollected: Yup.string().nullable(),

    raceEthnicTwoOrMoreRacesEthnicities: Yup.string().nullable(),
    raceEthnicTwoOrMoreRacesEthnicitiesNotCollected: Yup.string().nullable(),

    raceEthnicOther: Yup.string().nullable(),
    raceEthnicOtherNotCollected: Yup.string().nullable(),

    raceEthnicUnknown: Yup.string().nullable(),
    raceEthnicUnknownNotCollected: Yup.string().nullable(),

    raceEthnicTotalMembers: Yup.string().nullable(),

    genderFemale: Yup.string().nullable(),
    genderFemaleNotCollected: Yup.string().nullable(),

    genderMale: Yup.string().nullable(),
    genderMaleNotCollected: Yup.string().nullable(),

    genderUnknown: Yup.string().nullable(),
    genderUnknownNotCollected: Yup.string().nullable(),

    genderTotalMembers: Yup.string().nullable()
  });

  const handelGetCall = success => {
    setLoader(true);
    handleGetParticipantsData(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    )
      .then(res => {
        if (res && res.status && String(res.status).startsWith('2')) {
          setLoader(false);
          if (success) {
            setSuccessPopup(true);
          }
        } else {
          setLoader(false);
          setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
          setErrorPopup(true);
        }
      })
      .catch(err => {
        setLoader(false);
        setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
        setErrorPopup(true);
      });
  };

  useEffect(() => {
    handelGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))['participants']
        ?.Instruction
    );
    return () => {
      handleResetRedux('getOvernightCampParticipantsList');
    };
  }, []);

  const handleShowHelp = () => {
    setHelp(true);
  };

  const hideShowHelp = () => {
    setHelp(false);
  };

  const getClassNames = (errorsValue, touchedValue, checkboxValue) => {
    let className = 'ymca-field';

    if (errorsValue && touchedValue) {
      className = 'ymca-field invalid';
    } else if (checkboxValue) {
      className = 'ymca-field ymca-fieldDisabled';
    }
    return className;
  };

  const handleChange = (e, setFieldValue, name) => {
    const result = e.target.value.replace(/\D+/g, '');
    setFieldValue(name, result);
  };

  const convertedValue = value => (value === 0 || value ? Number(value) : null);

  const calculateTotal = (
    number1 = 0,
    number2 = 0,
    number3 = 0,
    number4 = 0,
    number5 = 0,
    number6 = 0,
    number7 = 0,
    number8 = 0,
    number9 = 0,
    number10 = 0,
    number11 = 0
  ) =>
    Number(number1) +
    Number(number2) +
    Number(number3) +
    Number(number4) +
    Number(number5) +
    Number(number6) +
    Number(number7) +
    Number(number8) +
    Number(number9) +
    Number(number10) +
    Number(number11);

  const onSubmit = values => {
    setLoader(true);
    const genderTotal = calculateTotal(
      values?.genderMaleNotCollected ? 0 : values?.genderMale,
      values?.genderFemaleNotCollected ? 0 : values.genderFemale,
      values?.genderUnknownNotCollected ? 0 : values.genderUnknown
    );
    const raceTotal = calculateTotal(
      values?.raceEthnicAsianNotCollected ? 0 : values?.raceEthnicAsian,
      values?.raceEthnicBlackOrAfricanAmericanNotCollected
        ? 0
        : values?.raceEthnicBlackOrAfricanAmerican,
      values?.raceEthnicHispanicLatinoNotCollected
        ? 0
        : values?.raceEthnicHispanicLatino,
      values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
        ? 0
        : values?.raceEthnicMiddleEasternOrNorthernAfrican,
      values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
        ? 0
        : values?.raceEthnicNativeAmericanOrAlaskanNative,
      values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
        ? 0
        : values?.raceEthnicNativeHawaiianOrOtherPacificIslander,
      values?.raceEthnicWhiteNotCollected ? 0 : values?.raceEthnicWhite,
      values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
        ? 0
        : values?.raceEthnicTwoOrMoreRacesEthnicities,
      values?.raceEthnicOtherNotCollected ? 0 : values?.raceEthnicOther,
      values?.raceEthnicUnknownNotCollected ? 0 : values?.raceEthnicUnknown
    );

    const totalNumberOfUnique = Number(values?.totalNumberOfUnique);
    if (genderTotal !== raceTotal) {
      setLoader(false);
      setTotalIsNotEqual(true);
      setErrorMessageForTotal(
        '* The total number of race/ethnicity, and sex must match.'
      );
    } else if (
      genderTotal < totalNumberOfUnique ||
      raceTotal < totalNumberOfUnique
    ) {
      setLoader(false);
      setTotalIsNotEqual(true);
      setErrorMessageForTotal(
        '* The total number of unique (unduplicated) Campers must be smaller than total campers'
      );
    } else {
      setLoader(false);
      setTotalIsNotEqual(false);
      setErrorMessageForTotal('');
    }

    const payloadBody = {
      Participants: {
        ParticipantId: GetParticipantsData?.Participants?.ParticipantId ?? 0,

        Year: ApiParameterData?.year,
        BranchNumber: ApiParameterData?.branchNumber,
        ReportBatchId: ApiParameterData?.reportBatchId,

        CreatedByPersonId: LoginUserData?.user?.personBranchId,
        UpdatedByName: LoginUserData?.user?.userName,
        UpdatedByPersonId: LoginUserData?.user?.personBranchId,

        TotNoOfUnDuplicatedCampersServed: convertedValue(
          values?.totalNumberOfUnique
        ),
        TotNoOfOverNightSummerCampersReturning: convertedValue(
          values?.totalOvernightSummerCampers
        ),

        Asian: values?.raceEthnicAsianNotCollected
          ? null
          : convertedValue(values?.raceEthnicAsian),
        AsianNotCollected: values?.raceEthnicAsianNotCollected,

        BlackOrAfricanAmerican:
          values?.raceEthnicBlackOrAfricanAmericanNotCollected
            ? null
            : convertedValue(values?.raceEthnicBlackOrAfricanAmerican),
        BlackOrAfricanAmericanNotCollected:
          values?.raceEthnicBlackOrAfricanAmericanNotCollected,

        HispanicLatino: values?.raceEthnicHispanicLatinoNotCollected
          ? null
          : convertedValue(values?.raceEthnicHispanicLatino),
        HispanicLatinoNotCollected:
          values?.raceEthnicHispanicLatinoNotCollected,

        MiddleEastNorthAfrican:
          values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
            ? null
            : convertedValue(values?.raceEthnicMiddleEasternOrNorthernAfrican),
        MiddleEastNorthAfricanNotCollected:
          values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected,

        NativeAmericanAlaskanNative:
          values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
            ? null
            : convertedValue(values?.raceEthnicNativeAmericanOrAlaskanNative),
        NativeAmericanAlaskanNativeNotCollected:
          values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected,

        NativeHawaiOtherPacificIslander:
          values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
            ? null
            : convertedValue(
                values?.raceEthnicNativeHawaiianOrOtherPacificIslander
              ),
        NativeHawaiOtherPacificIslanderNotCollected:
          values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected,

        White: values?.raceEthnicWhiteNotCollected
          ? null
          : convertedValue(values?.raceEthnicWhite),
        WhiteNotCollected: values?.raceEthnicWhiteNotCollected,

        TwoOrMoreRaces: values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
          ? null
          : convertedValue(values?.raceEthnicTwoOrMoreRacesEthnicities),
        TwoOrMoreRacesNotCollected:
          values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected,

        RaceUnknown: values?.raceEthnicUnknownNotCollected
          ? null
          : convertedValue(values?.raceEthnicUnknown),
        RaceUnknownNotCollected: values?.raceEthnicUnknownNotCollected,

        Other: values?.raceEthnicOtherNotCollected
          ? null
          : convertedValue(values?.raceEthnicOther),
        OtherNotCollected: values?.raceEthnicOtherNotCollected,

        Male: values?.genderMaleNotCollected
          ? null
          : convertedValue(values?.genderMale),
        MaleNotCollected: values?.genderMaleNotCollected,

        Female: values?.genderFemaleNotCollected
          ? null
          : convertedValue(values?.genderFemale),
        FemaleNotCollected: values?.genderFemaleNotCollected,

        Unknown: values?.genderUnknownNotCollected
          ? null
          : convertedValue(values?.genderUnknown),
        UnknownNotCollected: values?.genderUnknownNotCollected
      }
    };

    setSuccessPopup(false);

    handlePostParticipants(payloadBody).then(res => {
      if (res.status === 201 && res?.data?.isSuccess) {
        setResStatus(res.data?.recordStatus);
        handelGetCall(true);
        handleGetCampReportsDashboard(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year
        );
      } else if (res.statusCode === 409) {
        setLoader(false);
        setErrorMessage(res.errorMessage);
        setErrorPopup(true);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  };

  return (
    <>
      <button
        type="button"
        className="ymca-help-link text-decoration-none ymca-up-data-help-link annual-report-help"
        onClick={handleShowHelp}
      >
        <span>HELP</span>
        <img src={helpicon} className="img-fluid" alt="caret-icon" />
      </button>

      <div className="ymca-program mb-2">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2 pb-3">
          <div className="ymca-instructionBoxes">
            <h4 className="ymca-instructHeadline">{APP_LABELS.INSTRUCTIONS}</h4>
            <p className="ymca-instructTitle">
              <div
                dangerouslySetInnerHTML={{
                  __html: instructions
                }}
              />
            </p>
          </div>
        </div>

        {GetParticipantsData?.Participants?.RecordStatus === 'Partial' && (
          <PartialSaveWarningPopup />
        )}

        <Formik
          innerRef={formikref}
          initialValues={editValues || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, touched, dirty }) => {
            sessionStorage.setItem('dirty', dirty);
            return (
              <Form autoComplete="off">
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Campers</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">
                          What is the total number of unique (unduplicated)
                          Campers served in the previous Summers Overnight Camp
                          Season?
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalNumberOfUnique"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalNumberOfUnique,
                              touched.totalNumberOfUnique
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalNumberOfUnique'
                              )
                            }
                            value={values.totalNumberOfUnique}
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          How many of the total Overnight Summer Campers are
                          returning from a previous season?
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalOvernightSummerCampers"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalOvernightSummerCampers,
                              touched.totalOvernightSummerCampers
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalOvernightSummerCampers'
                              )
                            }
                            value={values.totalOvernightSummerCampers}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="totalOvernightSummerCampers"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      {/* {APP_LABELS.AR_EMPLOYEE_HEAD_COUNT_TEXT} */}
                      Please tell us how many of your Overnight Summer Campers
                      fall into each of the Race/Ethnicity categories below. The
                      total No. of Campers reported using the Race/Ethnicity and
                      Sex table below much match the total number of Overnight
                      Summer Campers reported above.
                    </div>
                  </div>
                </div>
                <span className="ymca-program p-0">
                  <h6 className="ymca-programActivities">
                    Please click in the checkbox if this Race/Ethnic category is
                    not collected.
                  </h6>
                </span>

                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Campers</th>
                        <th className="ymca-defaultSpace">Not Collected</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">Asian</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicAsian"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicAsian,
                              touched.raceEthnicAsian,
                              values.raceEthnicAsianNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicAsian')
                            }
                            value={
                              values.raceEthnicAsianNotCollected
                                ? ''
                                : values.raceEthnicAsian
                            }
                            disabled={values.raceEthnicAsianNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicAsian"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicAsianNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Black or African American
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicBlackOrAfricanAmerican"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicBlackOrAfricanAmerican,
                              touched.raceEthnicBlackOrAfricanAmerican,
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicBlackOrAfricanAmerican'
                              )
                            }
                            value={
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                                ? ''
                                : values.raceEthnicBlackOrAfricanAmerican
                            }
                            disabled={
                              values.raceEthnicBlackOrAfricanAmericanNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicBlackOrAfricanAmerican"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicBlackOrAfricanAmericanNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Hispanic/Latino</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicHispanicLatino"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicHispanicLatino,
                              touched.raceEthnicHispanicLatino,
                              values.raceEthnicHispanicLatinoNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicHispanicLatino'
                              )
                            }
                            value={
                              values.raceEthnicHispanicLatinoNotCollected
                                ? ''
                                : values.raceEthnicHispanicLatino
                            }
                            disabled={
                              values.raceEthnicHispanicLatinoNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicHispanicLatino"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicHispanicLatinoNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Middle Eastern or Northern African
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicMiddleEasternOrNorthernAfrican"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicMiddleEasternOrNorthernAfrican,
                              touched.raceEthnicMiddleEasternOrNorthernAfrican,
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicMiddleEasternOrNorthernAfrican'
                              )
                            }
                            value={
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                                ? ''
                                : values.raceEthnicMiddleEasternOrNorthernAfrican
                            }
                            disabled={
                              values.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicMiddleEasternOrNorthernAfrican"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicMiddleEasternOrNorthernAfricanNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Native American or Alaskan Native
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicNativeAmericanOrAlaskanNative"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicNativeAmericanOrAlaskanNative,
                              touched.raceEthnicNativeAmericanOrAlaskanNative,
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicNativeAmericanOrAlaskanNative'
                              )
                            }
                            value={
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                                ? ''
                                : values.raceEthnicNativeAmericanOrAlaskanNative
                            }
                            disabled={
                              values.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicNativeAmericanOrAlaskanNative"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicNativeAmericanOrAlaskanNativeNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Native Hawalian or Other Pacific Islander
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicNativeHawaiianOrOtherPacificIslander"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              touched.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicNativeHawaiianOrOtherPacificIslander'
                              )
                            }
                            value={
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                                ? ''
                                : values.raceEthnicNativeHawaiianOrOtherPacificIslander
                            }
                            disabled={
                              values.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicNativeHawaiianOrOtherPacificIslander"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">White</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicWhite"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicWhite,
                              touched.raceEthnicWhite,
                              values.raceEthnicWhiteNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicWhite')
                            }
                            value={
                              values.raceEthnicWhiteNotCollected
                                ? ''
                                : values.raceEthnicWhite
                            }
                            disabled={values.raceEthnicWhiteNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicWhite"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicWhiteNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Two or More Races/Ethnicities
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicTwoOrMoreRacesEthnicities"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicTwoOrMoreRacesEthnicities,
                              touched.raceEthnicTwoOrMoreRacesEthnicities,
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicTwoOrMoreRacesEthnicities'
                              )
                            }
                            value={
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                                ? ''
                                : values.raceEthnicTwoOrMoreRacesEthnicities
                            }
                            disabled={
                              values.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                            }
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicTwoOrMoreRacesEthnicities"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicTwoOrMoreRacesEthnicitiesNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Other</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicOther"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicOther,
                              touched.raceEthnicOther,
                              values.raceEthnicOtherNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'raceEthnicOther')
                            }
                            value={
                              values.raceEthnicOtherNotCollected
                                ? ''
                                : values.raceEthnicOther
                            }
                            disabled={values.raceEthnicOtherNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicOther"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicOtherNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Unknown / Unprovided</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicUnknown"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.raceEthnicUnknown,
                              touched.raceEthnicUnknown,
                              values.raceEthnicUnknownNotCollected
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'raceEthnicUnknown'
                              )
                            }
                            value={
                              values.raceEthnicUnknownNotCollected
                                ? ''
                                : values.raceEthnicUnknown
                            }
                            disabled={values.raceEthnicUnknownNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicUnknown"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="raceEthnicUnknownNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="raceEthnicTotalMembers"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.raceEthnicAsianNotCollected
                                ? 0
                                : values?.raceEthnicAsian,
                              values?.raceEthnicBlackOrAfricanAmericanNotCollected
                                ? 0
                                : values?.raceEthnicBlackOrAfricanAmerican,
                              values?.raceEthnicHispanicLatinoNotCollected
                                ? 0
                                : values?.raceEthnicHispanicLatino,
                              values?.raceEthnicMiddleEasternOrNorthernAfricanNotCollected
                                ? 0
                                : values?.raceEthnicMiddleEasternOrNorthernAfrican,
                              values?.raceEthnicNativeAmericanOrAlaskanNativeNotCollected
                                ? 0
                                : values?.raceEthnicNativeAmericanOrAlaskanNative,
                              values?.raceEthnicNativeHawaiianOrOtherPacificIslanderNotCollected
                                ? 0
                                : values?.raceEthnicNativeHawaiianOrOtherPacificIslander,
                              values?.raceEthnicWhiteNotCollected
                                ? 0
                                : values?.raceEthnicWhite,
                              values?.raceEthnicTwoOrMoreRacesEthnicitiesNotCollected
                                ? 0
                                : values?.raceEthnicTwoOrMoreRacesEthnicities,
                              values?.raceEthnicOtherNotCollected
                                ? 0
                                : values?.raceEthnicOther,
                              values?.raceEthnicUnknownNotCollected
                                ? 0
                                : values?.raceEthnicUnknown
                            )}
                            disabled
                          />
                          <ErrorMessage
                            component={TextError}
                            name="raceEthnicTotalMembers"
                          />
                        </td>

                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      {/* {APP_LABELS.AR_EMPLOYEE_HEAD_COUNT_TEXT} */}
                      Please tell us how many of your Overnight Summer Campers
                      fall into each of the Sex below. The total No. of Campers
                      reported using the Sex table below much match the total
                      number of Overnight Summer Campers reported above.
                    </div>
                  </div>
                </div>
                <span className="ymca-program p-0">
                  <h6 className="ymca-programActivities">
                    Please click in the checkbox if this Sex is not collected.
                  </h6>
                </span>
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>No. of Campers</th>
                        <th className="ymca-defaultSpace">Not Collected</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">Female</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderFemale"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderFemale,
                              touched.genderFemale,
                              values.genderFemaleNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderFemale')
                            }
                            value={
                              values.genderFemaleNotCollected
                                ? ''
                                : values.genderFemale
                            }
                            disabled={values.genderFemaleNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="genderFemale"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderFemaleNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Male</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderMale"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderMale,
                              touched.genderMale,
                              values.genderMaleNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderMale')
                            }
                            value={
                              values.genderMaleNotCollected
                                ? ''
                                : values.genderMale
                            }
                            disabled={values.genderMaleNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="genderMale"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderMaleNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Unknown / Unprovided</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderUnknown"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.genderUnknown,
                              touched.genderUnknown,
                              values.genderUnknownNotCollected
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'genderUnknown')
                            }
                            value={
                              values.genderUnknownNotCollected
                                ? ''
                                : values.genderUnknown
                            }
                            disabled={values.genderUnknownNotCollected}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="genderUnknown"
                          />
                        </td>
                        <td className="ymca-normalWrap">
                          <div className="ymca-areaBox mb-0">
                            <Field
                              name="genderUnknownNotCollected"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="genderTotalMembers"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values?.genderMaleNotCollected
                                ? 0
                                : values?.genderMale,
                              values?.genderFemaleNotCollected
                                ? 0
                                : values.genderFemale,
                              values?.genderUnknownNotCollected
                                ? 0
                                : values.genderUnknown
                            )}
                            disabled
                          />
                          <ErrorMessage
                            component={TextError}
                            name="genderTotalMembers"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  {totalIsNotEqual && (
                    <div className="d-flex flex-column">
                      <p className="errorNote  position-static fw-bold">
                        {errorMessageForTotal}
                      </p>
                    </div>
                  )}
                </div>

                <div className="ymca-submitHighlighter">
                  <LastUpdateName
                    Username={
                      GetParticipantsData?.Participants?.UpdatedByName ||
                      GetParticipantsData?.Participants?.CreatedByName
                    }
                    Time={
                      GetParticipantsData?.Participants?.UpdatedDatetime ||
                      GetParticipantsData?.Participants?.CreatedDateTime
                    }
                  />
                </div>
                {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                  <button
                    type="submit"
                    className="btn ymca-savingBTN ymca-btnRightUntitled float-end mt-5"
                    disabled={
                      status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                    }
                  >
                    Save
                  </button>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
      {successPopup && <SuccessToaster Status={resStatus} />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
      {help && <Help hidePopup={hideShowHelp} keyValue="participants" />}
    </>
  );
};

Participants.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handlePostParticipants: PropTypes.func.isRequired,
  handleGetParticipantsData: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,

  status: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  GetParticipantsData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleResetRedux: resetReduxState,
  handlePostParticipants: postOvernightCampDataParticipants,
  handleGetParticipantsData: getOvernightCampDataParticipantsList,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  GetParticipantsData: GetParticipantsDataSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Participants));
